// NeuralNoizz edit - formularz vouchera 
 
(function() {
  function syncVoucherInputs() {
    var checkbox = document.getElementById('is-voucher');
    var vpVoucher  = document.getElementById('vp-voucher');
    var vpImie     = document.getElementById('vp-imie');
    var vpNazwisko = document.getElementById('vp-nazwisko');

    if (!checkbox || !vpVoucher || !vpImie || !vpNazwisko) return;

    function update() {
      var checked = checkbox.checked;
      vpVoucher.disabled  = !checked;
      vpImie.disabled     = !checked;
      vpNazwisko.disabled = !checked;

      vpVoucher.value  = checked ? 'Tak' : '';
      vpImie.value     = checked ? (document.getElementById('voucher-imie') || {}).value || '' : '';
      vpNazwisko.value = checked ? (document.getElementById('voucher-nazwisko') || {}).value || '' : '';
    }

    // Sync on checkbox change
    checkbox.addEventListener('change', update);

    // Sync live as user types in the text fields
    var fieldImie = document.getElementById('voucher-imie');
    var fieldNazwisko = document.getElementById('voucher-nazwisko');

    if (fieldImie) fieldImie.addEventListener('input', update);
    if (fieldNazwisko) fieldNazwisko.addEventListener('input', update);

    // Final sync on form submit (safety net)
    document.querySelectorAll('form[id*="product-form"]').forEach(function(form) {
      form.addEventListener('submit', update);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncVoucherInputs);
  } else {
    syncVoucherInputs();
  }
})();
